import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { linkOpen } from "utils/util";
import CmsPreviewShell from "./CmsPreviewShell";

import "swiper/css";

const BannerComponent = ({ title, layout, items = [] }) => {
  const navigate = useNavigate();
  const handleClick = (link) => linkOpen(link, navigate);

  if (layout === "slide") {
    return (
      <CmsPreviewShell>
        <Swiper
          className="cms-banner cms-banner--slide"
          modules={[Autoplay]}
          slidesPerView={1}
          spaceBetween={8}
          loop={items.length > 1}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
        >
          {items.map((item, idx) => (
            <SwiperSlide
              key={item.id}
              className="cms-banner__item"
              style={{borderRadius:0}}
              onClick={() => handleClick(item.link)}
            >
              <div className="cms-banner__item-content">
                <img src={item.img} alt={item.title} className="cms-banner__item-image" />
                <div className="cms-banner__item-order">{`${idx + 1} / ${items.length}`}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </CmsPreviewShell>
    );
  }

  return (
    <CmsPreviewShell>
      <div className={`cms-banner cms-banner--${layout}`}>
        {items.map((item) => (
          <div
            key={item.id}
            className="cms-banner__item"
            onClick={() => handleClick(item.link)}
          >
            <img src={item.img} alt={item.title} />
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default BannerComponent;
